export function formatNumber(number, locale) {
    return number.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export function formatNumberCz(number) {
    return formatNumber(number, 'cs-CZ');
}
